import React from 'react';
import { Globe, Lock, FileText } from 'lucide-react';

interface BrandStatusPopupProps {
  brand: any;
  isGlobalDarkMode: boolean;
  showStatusPopup: string | null;
  setShowStatusPopup: (id: string | null) => void;
  handleStatusChange: (brandId: string, status: 'live' | 'private' | 'draft') => void;
  getStatusInfo: (status: string) => any;
  isGridView?: boolean;
}

export const BrandStatusPopup: React.FC<BrandStatusPopupProps> = ({
  brand,
  isGlobalDarkMode,
  showStatusPopup,
  setShowStatusPopup,
  handleStatusChange,
  getStatusInfo,
  isGridView = false
}) => {
  const statusInfo = getStatusInfo(brand.status);

  const getPositionClasses = () => {
    if (isGridView) {
      return 'absolute top-4 left-4';
    } else {
      return 'relative';
    }
  };

  const getDropdownPositionClasses = () => {
    return 'absolute top-8 left-0 z-40';
  };

  return (
    <div className={`status-container ${getPositionClasses()}`}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowStatusPopup(showStatusPopup === brand.id ? null : brand.id);
        }}
        className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 hover:scale-105 ${
          brand.status === 'live' || !brand.status
            ? 'bg-green-500 text-white'
            : brand.status === 'private'
            ? 'bg-yellow-500 text-white'
            : 'bg-muted text-muted-foreground'
        }`}
      >
        <div className="w-1.5 h-1.5 bg-current rounded-full opacity-80"></div>
        <span>{statusInfo.label}</span>
      </button>

      {showStatusPopup === brand.id && (
        <>
          <div
            className="fixed inset-0 z-30"
            onClick={(e) => {
              e.stopPropagation();
              setShowStatusPopup(null);
            }}
          />
          <div className={`${getDropdownPositionClasses()} rounded-xl border bg-popover border-border shadow-xl min-w-[140px] p-1.5`}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange(brand.id, 'live');
              }}
              className={`w-full px-3 py-2 text-left text-sm transition-colors flex items-center space-x-2 rounded-lg ${
                brand.status === 'live' || !brand.status
                  ? 'bg-green-500/10 text-green-600 dark:text-green-400'
                  : 'text-foreground hover:bg-accent'
              }`}
            >
              <Globe className="w-3 h-3" />
              <span>Live</span>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange(brand.id, 'private');
              }}
              className={`w-full px-3 py-2 text-left text-sm transition-colors flex items-center space-x-2 rounded-lg ${
                brand.status === 'private'
                  ? 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400'
                  : 'text-foreground hover:bg-accent'
              }`}
            >
              <Lock className="w-3 h-3" />
              <span>Private</span>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleStatusChange(brand.id, 'draft');
              }}
              className={`w-full px-3 py-2 text-left text-sm transition-colors flex items-center space-x-2 rounded-lg ${
                brand.status === 'draft'
                  ? 'bg-muted text-muted-foreground'
                  : 'text-foreground hover:bg-accent'
              }`}
            >
              <FileText className="w-3 h-3" />
              <span>Draft</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};
